<script setup lang="ts" generic="T">
import IconDown from 'assets/icons/arrow-down.svg';
import IconUp from 'assets/icons/arrow-up.svg';

export type TButtonType = 1 | 2 | '1' | '2' | 3 | '3';

const { t } = useI18n();

withDefaults(defineProps<{ vertical?: VerticalDirectionT; list: TOption<T>[]; buttonType?: TButtonType }>(),
  {
    buttonType: 2,
    vertical: 'down',
  },
);

const selectedOption = defineModel<TOption<T>>('selected', {
  default: { type: '', label: '' },
});

const emit = defineEmits<{
  (e: 'change', value: TOption<T>): void;
}>();

const onChange = (value: TOption<T>) => {
  console.log('onChange');
  emit('change', value);
};
</script>

<template>
  <HeadlessListbox
    v-slot="{ open }"
    v-model="selectedOption"
    :default-value="list[0]"
    as="div"
    class="relative cursor-pointer flex z-10"
  >
    <HeadlessListboxButton class="w-full">
      <slot
        name="button"
        :open="open"
      >
        <ButtonActive
          :active="open"
          class="w-full"
          :type="buttonType"
          :title="selectedOption?.label && t(selectedOption?.label)"
        >
          <template #append>
            <IconDown v-if="!open" />
            <IconUp v-else />
          </template>
        </ButtonActive>
      </slot>
    </HeadlessListboxButton>

    <transition
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <HeadlessListboxOptions
        as="div"
        :class="{
          'top-10': vertical === 'down',
          'bottom-10': vertical === 'up',
        }"
        class="absolute left-0 w-fit min-w-full rounded-medium bg-white shadow-highlight"
      >
        <HeadlessListboxOption
          v-for="(option, i) in list"
          v-slot="{ active }"
          :key="option.label"
          :disabled="option.available"
          :value="option"
          as="div"
          @click="onChange(option)"
        >
          <slot
            name="option"
            :type="option.type"
            :label="option.label"
            :index="i"
            :selected="selectedOption.type === option.type"
          >
            <div
              :class="[
                i === 0 ? 'rounded-t-medium' : '',
                i === list.length-1 ? 'rounded-b-medium' : '',
                active ? 'bg-gray-300 font-thicker !text-gray-900' : '',
                'w-full !justify-start text-big py-2 px-4 whitespace-nowrap ',
              ]"
            >
              {{ option.label && t(option.label) }}
            </div>
          </slot>
        </HeadlessListboxOption>
      </HeadlessListboxOptions>
    </transition>
  </HeadlessListbox>
</template>

<style scoped>

</style>
